import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciCheckboxComponent } from './luci-checkbox.component';



@NgModule({
  declarations: [LuciCheckboxComponent],
  exports: [LuciCheckboxComponent],
  imports: [
    CommonModule
  ]
})
export class LuciCheckboxModule { }
